export enum SidebarSectionSlotName {
  Header = "header",
}

export enum SidebarSectionItemSlotName {
  ButtonsRight = "buttonsRight",
}

export enum SidebarSectionHeaderSlotName {
  ButtonsRight = "buttonsRight",
}
